import { render } from "./FooterSearchIcon.vue?vue&type=template&id=3bed2efa"
const script = {}
script.render = render

export default script